export const QUALIFICATION_NAMES = {
    BASES: {
        KEY: 'bases',
        TYPE_CODE: 'typeCode',
        TYPE_NAME: 'typeName',
        YEAR_FROM_OPTIONAL: 'fromYear',
        YEAR_INTERVALS_OPTIONAL: 'yearIntervals',
        YEAR_TO_OPTIONAL: 'toYear',
    },
    KEY: 'qualifications',
    LANGUAGE_CODE_OPTIONAL: 'languageCode',
    LANGUAGE_NAME_OPTIONAL: 'languageName',
    ORIENTATION_CODE_OPTIONAL: 'orientationCode',
    ORIENTATION_NAME_OPTIONAL: 'orientationName',
    STUDYPATH_CODE_OPTIONAL: 'studyPathCode',
    STUDYPATH_NAME_OPTIONAL: 'studyPathName',
    SUBJECT_CODE_OPTIONAL: 'subjectCode',
    SUBJECT_NAME_OPTIONAL: 'subjectName',
    TYPE_CODE: 'typeCode',
    TYPE_NAME: 'typeName',
    TYPE_OF_SCHOOLING_CODE_OPTIONAL: 'typeOfSchoolingCode',
    TYPE_OF_SCHOOLING_NAME_OPTIONAL: 'typeOfSchoolingName',
};

export const APPLICANT_NAMES = {
    ADDRESS: 'applicantAddress',
    CITY: 'applicantCity',
    EMAIL: 'applicantEmail',
    KEY: 'applicant',
    NAME: 'applicantName',
    PHONE: 'applicantPhone',
    POSTAL_CODE: 'applicantPostalCode',
};

export const DEGREE_NAMES = {
    FIRST: {
        INSTITUTION_CODE: 'code',
        INSTITUTION_NAME: 'name',
        KEY: 'firstExamina',
        YEAR: 'year',
    },
    KEY: 'degree',
    SECOND_OPTIONAL: {
        INSTITUTION_CODE: 'code',
        INSTITUTION_NAME: 'name',
        KEY: 'secondExamina',
        YEAR: 'year',
    },
};

export const ATTACHMENT_NAMES = {
    ATTACHMENTS: {
        CONTENT: 'content',
        FILE_NAME: 'fileName',
        KEY: 'attachments',
        SIZE: 'size',
    },
    DELIVERY_METHOD: 'deliveryMethod',
    KEY: 'attachments',
};

export const SPEICAL_EDUCATION_NAMES = {
    KEY: 'specialEducation',
    SPECIAL_EDUCATION_TEACHER: 'specialEducationTeacher',
};

export const PAGE_NAMES = {
    APPLICANT: APPLICANT_NAMES,
    ATTACHMENTS: ATTACHMENT_NAMES,
    DEGREE: DEGREE_NAMES,
    OTHER_QUALIFICATION: {
        KEY: 'otherQualification',
        QUALIFICATIONS: QUALIFICATION_NAMES,
    },
    SPECIAL_EDUCATION: {
        KEY: 'specialEducation',
        SPECIAL_EDUCATION_TEACHER: 'specialEducationTeacher',
    },
    VOCATIONAL_QUALIFICATION: {
        KEY: 'vocationalQualification',
        QUALIFICATIONS: QUALIFICATION_NAMES,
    },
};

export const APPLICATION_NAMES = {
    APPLICANT_SSN: 'applicantSsn',
    APPLICATION_TYPE: 'type',
    ARRIVAL_DATE: 'dateOfArrival',
    CASE_ID: 'skolverketCaseId',
    PAYMENT: 'payment',
    TAGS: 'tags',
    USER_CONFIRMATION: 'userConfirmation',
};
